




















import {
    cChainExplorerURL,
    cChainExplorerURL_test,
    DEFAULT_NETWORK_ID,
} from '@/store/modules/network/network'
import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { abbreviateBech32, abbreviateHex } from '@/helper'

@Component({})
export default class AddressLink extends Vue {
    @Prop() address!: string

    get isBech32() {
        const prefix = this.address.substring(0, 2)
        return prefix !== '0x' ? true : false
    }

    get internalURL() {
        return `/address/${this.address}`
    }

    get externalURL() {
        return `${
            DEFAULT_NETWORK_ID === 1
                ? cChainExplorerURL
                : cChainExplorerURL_test
        }/address/${this.address}`
    }

    get abbrev32() {
        return abbreviateBech32(this.address)
    }

    get abbrevHex() {
        return abbreviateHex(this.address)
    }
}
